import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'submitButton'
  ]

  static values = {
    disable: Boolean
  }

  connect() {
    if (this.disableValue && this.hasSubmitButtonTarget) {
      this.disableButton()
    }
  }

  unDisableButton() {
    this.submitButtonTarget.disabled = false
  }

  disableButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }
}
